//# sourceMappingURL=data_sources.mjs.map
/// <reference types="./data_sources.d.mts" />
import * as $remote from "../../../data_types/data/remote.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $dict from "../../../gleam_stdlib/gleam/dict.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import * as $pair from "../../../gleam_stdlib/gleam/pair.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $effect from "../../../redraw_lustre/redraw/lustre/effect.mjs";
import * as $data_sources from "../../data/data_sources.mjs";
import * as $msg from "../../data/msg.mjs";
import * as $store from "../../data/store.mjs";

export function update(store, msg) {
  if (msg instanceof $msg.ApiReturnedDataSource) {
    let page = msg.page;
    let source = msg.source;
    let _pipe = store.data_sources.sources;
    let _pipe$1 = $dict.upsert(
      _pipe,
      source.org_id,
      (questions) => {
        if (questions instanceof $option.Some) {
          let questions$1 = questions[0];
          return $dict.upsert(
            questions$1,
            page,
            (questions) => {
              if (questions instanceof $option.Some) {
                let $ = questions[0];
                if ($ instanceof $remote.NotLoaded) {
                  return new $remote.NotLoaded();
                } else if ($ instanceof $remote.Loading) {
                  return new $remote.Loading();
                } else if ($ instanceof $remote.Errored) {
                  let e = $[0];
                  return new $remote.Errored(e);
                } else {
                  let questions$1 = $[0];
                  let _pipe$1 = $list.key_find(questions$1, source.document_id);
                  let _pipe$2 = $result.map(
                    _pipe$1,
                    (questions) => {
                      return $list.map(
                        questions,
                        (q) => {
                          let is_source = q.id === source.id;
                          return $bool.guard(
                            !is_source,
                            q,
                            () => { return source; },
                          );
                        },
                      );
                    },
                  );
                  let _pipe$3 = $result.map(
                    _pipe$2,
                    (_capture) => {
                      return $list.key_set(
                        questions$1,
                        source.document_id,
                        _capture,
                      );
                    },
                  );
                  let _pipe$4 = $result.unwrap(_pipe$3, questions$1);
                  return new $remote.Loaded(_pipe$4);
                }
              } else {
                return new $remote.NotLoaded();
              }
            },
          );
        } else {
          return $dict.new$();
        }
      },
    );
    let _pipe$2 = ((_capture) => {
      return $data_sources.set_sources(store.data_sources, _capture);
    })(_pipe$1);
    let _pipe$3 = ((_capture) => {
      return $store.set_data_sources(store, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  } else if (msg instanceof $msg.ApiStartedLoadingDataSources) {
    let organization = msg.org_id;
    let page = msg.page;
    let _pipe = store.data_sources;
    let _pipe$1 = $data_sources.loading(_pipe, organization, page);
    let _pipe$2 = ((_capture) => {
      return $store.set_data_sources(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else if (msg instanceof $msg.ApiErroredDataSources) {
    let org_id = msg.org_id;
    let page = msg.page;
    let error = msg.error;
    let _pipe = store.data_sources;
    let _pipe$1 = $data_sources.errored(_pipe, org_id, page, error);
    let _pipe$2 = ((_capture) => {
      return $store.set_data_sources(store, _capture);
    })(_pipe$1);
    return $pair.new$(_pipe$2, $effect.none());
  } else {
    let organization = msg.org_id;
    let page = msg.page;
    let total = msg.total;
    let sources = msg.sources;
    let _pipe = store.data_sources;
    let _pipe$1 = $data_sources.total(_pipe, organization, total);
    let _pipe$2 = $data_sources.loaded(_pipe$1, organization, page, sources);
    let _pipe$3 = ((_capture) => {
      return $store.set_data_sources(store, _capture);
    })(_pipe$2);
    return $pair.new$(_pipe$3, $effect.none());
  }
}
